<div *ngIf="cs.isBrowser" [formGroup]="form" class="form-group" [ngClass]="field?.styleClass">
  <label *ngIf="field.label">
    {{ field.label }}{{ field.validation?.required ? '*' : '' }}
    <app-info-icon
      [message]="field.infoIconMessage"
      *ngIf="field.infoIconMessage"
    ></app-info-icon>
  </label>
  <div class="custom-phoneno">
    <ngx-intl-tel-input
      [cssClass]="'custom'"
      [preferredCountries]="field.mobile.preferredCountries"
      [enableAutoCountrySelect]="field.mobile.enableAutoCountrySelect"
      [enablePlaceholder]="field.mobile.enablePlaceholder"
      [searchCountryFlag]="field.mobile.searchCountryFlag"
      [searchCountryField]="[field.mobile.searchCountryField.Name]"
      [selectFirstCountry]="field.mobile.selectFirstCountry"
      [selectedCountryISO]="field.mobile.selectedCountryISO"
      [phoneValidation]="field.mobile.phoneValidation"
      [separateDialCode]="field.mobile.separateDialCode"
      [formControlName]="field.name"
      phoneMask
      (countryChange)="onCountryChange($event)"
      (keypress)="onKeyPress($event)"
    ></ngx-intl-tel-input>
  </div>
  <app-validation-errors
    [control]="form.get(field.name)"
    [field]="field"
  ></app-validation-errors>
</div>
